/* Converts "2019-03-21 12:00", "21.03.2019 12:00" or timestamp to date */
window.convertDateTimeStringToDate = function (datetime) {
    try {
        if (datetime) {
            if (typeof datetime === 'number') {
                return new Date(datetime);
            }
            else if (datetime.match(/^[0-9]+$/)) {
                return new Date(+datetime);
            }
            else if (datetime.match(/([0-9]{1,2}).([0-9]{1,2}).([0-9]{4}) ([0-9]{1,2}):([0-9]{2})/)) {
                const dateParts = datetime.match(/([0-9]{1,2}).([0-9]{1,2}).([0-9]{4}) ([0-9]{1,2}):([0-9]{2})/);
                return new Date(+dateParts[3], +dateParts[2] - 1, +dateParts[1], +dateParts[4], +dateParts[5], 0);
            }
            else {
                const dateParts = datetime.match(/([0-9]{4})-([0-9]{1,2})-([0-9]{1,2}) ([0-9]{1,2}):([0-9]{2})/);
                return new Date(+dateParts[1], +dateParts[2] - 1, +dateParts[3], +dateParts[4], +dateParts[5], 0);
            }
        }
    }
    catch (e) {
        return NaN;
    }
};
window.Math.clamp = function (value, from, to) {
    if (value < from) {
        return from;
    }
    else if (value > to) {
        return to;
    }
    return value;
};
window.Math.clamp01 = function (value) {
    return Math.clamp(value, 0, 1);
};
